import React, { useState } from "react";
import Gallery from "react-photo-gallery";
import { Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const ImageGrid = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const images = props.photos;
    const openLightbox = ((event, { photo, index }) => {
        setIsOpen(true);
        setIndex(index);
    });
    const closeLightbox = () => {
        setIsOpen(false);
    };

    const fadeProperties = {
        defaultIndex: index
    };

    const Slideshow = () => {
        return (
          <div className="slide-container">
            <Fade {...fadeProperties}>
              {images.map((each, index) => (
                <div className='photo-container'>
                    <img className='object-fit-image' alt={each.title} key={index} style={{ display:'block', margin:'auto', width: "80%" }} src={each.src} onClick={closeLightbox} />
                    <div class="caption">
                        <p>{each.title}</p>
                    </div>
                </div>
              ))}
            </Fade>
          </div>
        );
      };
  
    return (
      <div>
         {!(isOpen) ? <Gallery photos={props.photos} onClick={openLightbox} /> : <Slideshow />}
      </div>
    );
}

export default ImageGrid;